module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    style: ({
      color: _vm.selectedTheme.text,
      backgroundColor: _vm.selectedTheme.background,
      borderColor: _vm.selectedTheme.border
    }),
    attrs: {
      "id": "app"
    }
  }, [_c('svg', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('symbol', {
    attrs: {
      "id": "iconList",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconCaiet",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconCaret",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m 9.5,17.5 5,-5 -5,-5 z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconSearch",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconCheck",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconCheckOn",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconPrev",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconNext",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backdrop"
    }
  }, [(_vm.$store.state.sidebarLeftToggled || _vm.$store.state.sidebarRightToggled) ? _c('div', {
    staticClass: "backdrop backdrop--sidebar",
    style: ({
      backgroundColor: _vm.selectedTheme.backdrop
    }),
    on: {
      "click": _vm.closeSidebars
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sidebar-slide-left"
    }
  }, [_c('sidebar-left', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.sidebarLeftToggled),
      expression: "$store.state.sidebarLeftToggled"
    }],
    attrs: {
      "folderListSnap": _vm.folderListSnap,
      "theme": _vm.selectedTheme
    }
  })], 1), _vm._v(" "), _c('main', {
    staticClass: "app__main",
    style: ({
      backgroundColor: _vm.selectedTheme.background2
    })
  }, [_c('navbar', {
    attrs: {
      "theme": _vm.selectedTheme,
      "themes": _vm.themes
    },
    on: {
      "downloadFolderList": _vm.getFolderListSnap,
      "downloadPoems": _vm.getPoemsSnap
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-view",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "app__main-view",
    attrs: {
      "selectedPoem": _vm.selectedPoem,
      "theme": _vm.selectedTheme
    },
    on: {
      "downloadFolderList": _vm.getFolderListSnap,
      "downloadPoems": _vm.getPoemsSnap
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sidebar-slide-right"
    }
  }, [_c('sidebar-right', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.sidebarRightToggled),
      expression: "$store.state.sidebarRightToggled"
    }],
    attrs: {
      "poemsSnap": _vm.poemsSnap,
      "theme": _vm.selectedTheme
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backdrop"
    }
  }, [(_vm.$store.state.moreOpen) ? _c('div', {
    staticClass: "backdrop",
    style: ({
      backgroundColor: _vm.selectedTheme.backdrop
    }),
    on: {
      "click": _vm.toggleMore
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backdrop"
    }
  }, [(_vm.$store.state.moreOpen) ? _c('more', {
    attrs: {
      "theme": _vm.selectedTheme
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 131
// module chunks = 1